var map = {
	"./404.svg": 61286,
	"./bug.svg": 90572,
	"./chart.svg": 73342,
	"./clipboard.svg": 7256,
	"./component.svg": 43351,
	"./dashboard.svg": 6250,
	"./documentation.svg": 43304,
	"./drag.svg": 47240,
	"./edit.svg": 57678,
	"./education.svg": 4380,
	"./email.svg": 7958,
	"./example.svg": 34704,
	"./excel.svg": 57131,
	"./exit-fullscreen.svg": 16092,
	"./eye-open.svg": 63002,
	"./eye.svg": 79893,
	"./form.svg": 93528,
	"./fullscreen.svg": 92057,
	"./guide.svg": 20146,
	"./icon.svg": 67881,
	"./international.svg": 82494,
	"./language.svg": 74348,
	"./link.svg": 42114,
	"./list.svg": 94070,
	"./lock.svg": 26435,
	"./message.svg": 38215,
	"./money.svg": 95802,
	"./nested.svg": 17323,
	"./password.svg": 51281,
	"./pdf.svg": 68788,
	"./people.svg": 73463,
	"./peoples.svg": 82918,
	"./qq.svg": 4404,
	"./search.svg": 72570,
	"./shopping.svg": 33318,
	"./size.svg": 86493,
	"./skill.svg": 5605,
	"./star.svg": 24922,
	"./tab.svg": 70823,
	"./table.svg": 16414,
	"./theme.svg": 69,
	"./tree-table.svg": 45205,
	"./tree.svg": 68046,
	"./user.svg": 59067,
	"./wechat.svg": 62724,
	"./zip.svg": 41127
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15566;